import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <div className="w-full bg-secondary flex flex-col items-center  z-50 ">
            {/* Top Section */}
            <div className="w-full flex flex-col md:flex-row justify-between items-start gap-8 p-8 md:px-28 bg-secondary">
                {/* Brand Section */}
                <div className="flex flex-col items-start gap-4">
                    <h1 className="text-primary text-4xl font-playfair-display">Lumi Glass</h1>
                    <p className="text-primary font-nunito-sans">Your Vison, Our Glass Solutions</p>
                    <div className="justify-start text-primary text-sm md:text-lg font-light font-playfair-display tracking-[2.32px] md:tracking-[4.64px]">
                    Partnered with Bob's Glass Works
  </div>
                    <p className="text-primary font-nunito-sans">© 1985 — 2025</p>
                </div>

                {/* Quick Links */}
                <div className="flex flex-col gap-4">
                    <h2 className="text-primary font-bold font-nunito-sans">Quick Links</h2>
                    <ul className="flex flex-col gap-2">
                        <li><Link to="/" className="text-primary font-nunito-sans hover:underline">Home</Link></li>
                        <li><Link to="services/service_home" className="text-primary font-nunito-sans hover:underline">About</Link></li>
                        <li><Link to="/contact" className="text-primary font-nunito-sans hover:underline">Contact</Link></li>
                        <li><Link to="/faq" className="text-primary font-nunito-sans hover:underline">FAQs</Link></li>
                    </ul>
                </div>

                {/* Location */}
                <div className="flex flex-col gap-4">
    <h2 className="text-primary font-bold font-nunito-sans">Location</h2>
    <address className="text-primary font-nunito-sans not-italic">
        Bob’s Glass Work<br />
        749 Communipaw Ave<br />
        Jersey City, NJ<br />
        07304 USA
    </address>
    <a
        href={`https://www.google.com/maps/dir/?api=1&destination=749+Communipaw+Ave,+Jersey+City,+NJ+07304`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary font-nunito-sans underline cursor-pointer"
    >
        Get Directions
    </a>
</div>


                {/* Contact Us */}
                <div className="flex flex-col gap-4">
                    <h2 className="text-primary font-bold font-nunito-sans">Contact Us</h2>
                    <p className="text-primary font-nunito-sans">Mon - Fri: 8 am - 4 pm EST</p>
                    <p className="text-primary font-nunito-sans">Sat: 9 am - 1 pm EST</p>
                    <p className="text-primary font-nunito-sans">201-333-2931</p>
                    <p className="text-primary font-nunito-sans">sales@thelumiglass.com</p>
                </div>
            </div>

            {/* Bottom Section */}
            <div className="w-full bg-primary flex flex-col md:flex-row justify-center items-center gap-4 py-4">
                </div>
        </div>
    );
};

export default Footer;